import { __awaiter, __extends, __generator } from "tslib";
import { BaseApi } from '../BaseApi';
import { query as getProductQuery } from '../../graphql/getProduct.graphql';
import { query as getExtendedProductBySlugQuery } from '../../graphql/getExtendedProductBySlug.graphql';
import { query as getExtendedProductBySlugWithoutOptionalModifierMandatoryQuery } from '../../graphql/getExtendedProductBySlugWithoutOptionalModifierMandatory.graphql';
import { query as getExtendedProductByIdQuery } from '../../graphql/getExtendedProductById.graphql';
import { query as getExtendedProductByIdWithoutOptionalModifierMandatoryQuery } from '../../graphql/getExtendedProductByIdWithoutOptionalModifierMandatory.graphql';
import { query as getExtendedProductsListQuery } from '../../graphql/getExtendedProductsList.graphql';
import { query as getExtendedProductsListWithoutOptionalModifierMandatoryQuery } from '../../graphql/getExtendedProductsListWithoutOptionalModifierMandatory.graphql';
import { GraphQLOperations, RemoteSourceTypes } from '../constants';
import { NotFoundError } from '../errors/NotFoundError';
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductsApi.prototype.fetchProductSlug = function (productId) {
        return this.fetch({
            variables: { productId: productId },
            operationName: GraphQLOperations.GetProduct,
            query: getProductQuery,
        }, RemoteSourceTypes.ScalaReadOnly).then(function (response) { return response.data.catalog.product; });
    };
    ProductsApi.prototype.fetchExtendedProductBySlug = function (slug, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.includeOptionalModifierMandatory, includeOptionalModifierMandatory = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: { slug: slug },
                            operationName: includeOptionalModifierMandatory
                                ? GraphQLOperations.GetExtendedProductBySlug
                                : GraphQLOperations.GetExtendedProductBySlugWithoutOptionalModifierMandatory,
                            query: includeOptionalModifierMandatory
                                ? getExtendedProductBySlugQuery
                                : getExtendedProductBySlugWithoutOptionalModifierMandatoryQuery,
                        }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _d.sent();
                        if (response.data.catalog.product === null) {
                            throw new NotFoundError("cannot find a product with slug: ".concat(slug));
                        }
                        return [2 /*return*/, response.data.catalog.product];
                }
            });
        });
    };
    ProductsApi.prototype.fetchExtendedProductById = function (id, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.includeOptionalModifierMandatory, includeOptionalModifierMandatory = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: { id: id },
                            operationName: includeOptionalModifierMandatory
                                ? GraphQLOperations.GetExtendedProductById
                                : GraphQLOperations.GetExtendedProductByIdWithoutOptionalModifierMandatory,
                            query: includeOptionalModifierMandatory
                                ? getExtendedProductByIdQuery
                                : getExtendedProductByIdWithoutOptionalModifierMandatoryQuery,
                        }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _d.sent();
                        if (response.data.catalog.product === null) {
                            throw new NotFoundError("cannot find a product with id: ".concat(id));
                        }
                        return [2 /*return*/, response.data.catalog.product];
                }
            });
        });
    };
    ProductsApi.prototype.fetchDefaultProduct = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.includeOptionalModifierMandatory, includeOptionalModifierMandatory = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: {
                                limit: 1,
                                sortField: 'CreationDate',
                                direction: 'Descending',
                                onlyVisible: true,
                            },
                            operationName: includeOptionalModifierMandatory
                                ? GraphQLOperations.GetExtendedProductsList
                                : GraphQLOperations.GetExtendedProductsListWithoutOptionalModifierMandatory,
                            query: includeOptionalModifierMandatory
                                ? getExtendedProductsListQuery
                                : getExtendedProductsListWithoutOptionalModifierMandatoryQuery,
                        }, RemoteSourceTypes.ScalaReadOnly)];
                    case 1:
                        response = _d.sent();
                        if (response.data.catalog.products.list === null) {
                            throw new NotFoundError('no products in store');
                        }
                        return [2 /*return*/, response.data.catalog.products.list[0]];
                }
            });
        });
    };
    return ProductsApi;
}(BaseApi));
export { ProductsApi };
//# sourceMappingURL=ProductsApi.js.map